module.exports = __webpack_public_path__ + "static/media/gif1.c606e0a6.gif";